export default {"src":"/_next/static/media/sweat_logo_only.65b2566a.svg","height":20,"width":22,"blurWidth":0,"blurHeight":0};